/**
 * Build a personal, time-of-day aware greeting for the visitor PWA landing.
 * Copy is split into a lead ("Good morning , ") and an emphasis ("what's up?")
 * so the UI can render them with different weights.
 *
 * Localisation happens via i18n keys (greeting.morning, greeting.afternoon,
 * greeting.evening, greeting.night) with matching *.em variants. Callers
 * provide a `t` function and get back the two pieces.
 */

import type { TFunction } from 'i18next';

export type DayPeriod = 'morning' | 'afternoon' | 'evening' | 'night';

export function currentPeriod(now: Date = new Date()): DayPeriod {
  const h = now.getHours();
  if (h < 5) return 'night';
  if (h < 12) return 'morning';
  if (h < 17) return 'afternoon';
  if (h < 21) return 'evening';
  return 'night';
}

export interface Greeting {
  lead: string;
  em: string;
  period: DayPeriod;
}

export function buildGreeting(t: TFunction, now: Date = new Date()): Greeting {
  const period = currentPeriod(now);
  return {
    lead: t(`greeting.${period}`),
    em: t(`greeting.${period}Em`),
    period,
  };
}
